import apiClient from "./apiClient";

export const employeeService = {
  // The logged-in employee's full record (employee taken from the token).
  // The portal must never call /employee/:id routes.
  // -> { profile, personalDetails, addresses, contacts, emergencyContacts,
  //      education, employmentHistory, governmentDocuments, photoUrl }
  getMe: () => apiClient.get("/employee/me"),
};
